import { render, staticRenderFns } from "./ConfirmarTerritorio.vue?vue&type=template&id=24933798&scoped=true&lang=pug"
import script from "./ConfirmarTerritorio.vue?vue&type=script&lang=js"
export * from "./ConfirmarTerritorio.vue?vue&type=script&lang=js"
import style0 from "./ConfirmarTerritorio.vue?vue&type=style&index=0&id=24933798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24933798",
  null
  
)

export default component.exports